import React from 'react';
import { func } from 'prop-types';
import { reduxForm } from 'redux-form';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { ADD_ACCOUNT } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { clientNumberField } from 'constants/fields';

import styles from './styles';

const fields = [clientNumberField];

const AddAccount = ({ handleSubmit }) => (
  <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} style={styles.form}>
    <UTLabel black>{message('Accounts:createAccountMessage')}</UTLabel>
    <UTForm fields={fields} />
  </form>
);

AddAccount.propTypes = {
  handleSubmit: func.isRequired
};

export default WithLoading(props => props.loading)(reduxForm({ form: ADD_ACCOUNT })(AddAccount));
